// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".application-sent__title[data-v-79519a03]{color:#51596c;margin-bottom:25px;font-size:14px}", ""]);
// Exports
module.exports = exports;
